const ar = {
  translation: {
    "Sign in credentials": "بيانات تسجيل الدخول",
    "Sign in": "تسجيل الدخول",
    "Add Category": "إضافة فئة",
    Title: "العنوان",
    Description: "الوصف",
    Add: "إضافة",
    Remove: "إزالة",
    "Add/Remove": "إضافة/إزالة",
    Success: "نجاح",
    Danger: "خطر",
    Categories: "الفئات",
    Image: "صورة",
    Header: "رأس الصفحة",
    Loading: "جارٍ التحميل",
    Error: "خطأ",
    Edit: "تعديل",
    Delete: "حذف",
    "Edit Category": "تعديل الفئة",
    Save: "حفظ",
    "OrderID prefix": "بادئة رقم الطلب",
    Order: "الطلب",
    Email: "البريد الإلكتروني",
    Password: "كلمة المرور",
    Enable: "تمكين",
    Disable: "تعطيل",
    "Enable/Disable": "تمكين/تعطيل",
    Saving: "جارٍ الحفظ",
    Paypal: "باي بال",
    "Client ID": "معرف العميل",
    "Client Secret": "السر الخاص بالعميل",
    Sandbox: "صندوق رملي",
    "Publishable Key": "المفتاح القابل للنشر",
    "Secret Key": "المفتاح السري",
    "Delivery Charges": "رسوم التوصيل",
    Price: "السعر",
    "Add Food": "إضافة طعام",
    Category: "الفئة",
    Select: "اختيار",
    Variations: "التغييرات",
    Type: "النوع",
    "Food Image": "صورة الطعام",
    Foods: "الأطعمة",
    "Edit Food": "تعديل الطعام",
    OrderID: "رقم الطلب",
    Orders: "الطلبات",
    Name: "الاسم",
    Items: "العناصر",
    Payment: "الدفع",
    Status: "الحالة",
    Review: "المراجعة",
    "Mark as": "وسم كـ",
    Users: "المستخدمين",
    Phone: "الهاتف",
    Address: "العنوان",
    "2019-20": "2019-20",
    "About Us": "معلومات عنا",
    Blog: "مدونة",
    Welcome: "مرحبًا",
    Logout: "تسجيل الخروج",
    Dashboard: "لوحة القيادة",
    Configuration: "التكوين",
    Login: "تسجيل الدخول",
    Food: "الطعام",
    "Character limit of max length 50": "الحد الأقصى للحروف 50",
    "Character limit of max length 15": "الحد الأقصى للحروف 15",
    "Character limit of max length 60": "الحد الأقصى للحروف 60",
    "Character limit of max length 20": "الحد الأقصى للحروف 20",
    "Character limit of max length 140": "الحد الأقصى للحروف 140",
    Currency: "العملة",
    "Currency Code": "رمز العملة",
    "Currency Symbol": "رمز العملة",
    Notifications: "الإشعارات",
    purchaseText: "سيكون متاحاً حذف الميزة بعد شراء المنتج",
    code: "الكود",
    discount: "نسبة الخصم",
    totalOrders: "إجمالي الطلبات",
    totalUsers: "إجمالي المستخدمين",
    totalSales: "إجمالي المبيعات",
    averageTotal: "متوسط ​​التقييمات / إجمالي التقييمات",
    filterGraph: "تصفية الرسم البياني",
    startingDate: "تاريخ البدء",
    submit: "إرسال",
    overview: "نظرة عامة",
    performance: "الأداء",
    endingDate: "تاريخ الانتهاء",
    salesValue: "قيمة المبيعات",
    salesAmount: "مبلغ المبيعات",
    orderCount: "عدد الطلبات",
    categoryUpdated: "تم تحديث الفئة بنجاح",
    categoryAdded: "تمت إضافة الفئة بنجاح",
    actionFailed: "فشلت العملية. يرجى المحاولة مرة أخرى",
    egBreakfast: "على سبيل المثال، وجبة الإفطار",
    egAllHappiness: "على سبيل المثال، كل السعادة تعتمد على وجبة الإفطار الهادئة.",
    newAddon: 'إضافة جديدة',
    uniqueTitle: 'يجب أن يكون العنوان فريدًا',
    egSmall: 'على سبيل المثال، صغير',
    foodUpdated: "تم تحديث الطعام بنجاح",
    foodAdded: "تمت إضافة الطعام بنجاح",
    Addons: "الإضافات",
    Options: "الخيارات",
    selectOneOption: "اختر خيارًا واحدًا على الأقل",
    new: "جديد",
    addRemoveAddons: "إضافة/إزالة الإضافات",
    quantityMinimum: "الحد الأدنى للكمية",
    quantityMinText: "يجب أن يكون أقل من أو يساوي الحد الأقصى",
    quantityMaximum: "الحد الأقصى للكمية",
    quantityMaxText: "يجب أن يكون أكبر من أو يساوي الحد الأقصى",
    egPepsi: "على سبيل المثال: بيبسي",
    egOptional: "على سبيل المثال: اختياري",
    option: "خيار",
    mustBeANumber: "يجب أن يكون رقمًا",
    egTextOption: "على سبيل المثال: 90.25",
    saved: "تم الحفظ",
    errorOccured: "حدث خطأ أثناء الحفظ، حاول مرة أخرى",
    discounted: "مخفض السعر",
    eg99: "مثال 9.99",
    eg9: "مثال 9",
    filterByOrderId: "تصفية حسب رقم الطلب",
    datetime: "التاريخ والوقت",
    stock: "المخزون",
    Ratings: "التقييمات",
    Riders: "الركاب",
    addRider: "إضافة راكب",
    username: "اسم المستخدم",
    available: "متاح",
    riderUpdatedText: "تم تحديث الراكب بنجاح",
    riderAddedText: "تمت إضافة الراكب بنجاح",
    actions: "إجراء",
    editRider: "تحرير الراكب",
    Option: "خيار",
    minimum: "الحد الأدنى",
    maximum: "الحد الأقصى",
    Coupons: "القسائم",
    couponUpdatedText: "تم تحديث القسيمة",
    couponAddedText: "تمت إضافة القسيمة",
    actionFailedError: "فشلت العملية. يرجى المحاولة مرة أخرى",
    editCoupon: "تعديل القسيمة",
    addCoupon: "إضافة قسيمة",
    couponCode: "رمز القسيمة",
    discountPercent: "نسبة الخصم",
    btw1And100: "بين 1 و 100",
    enableDisable: "تمكين/تعطيل",
    egSales: "مثال: SALE50",
    body: 'الجسم',
    egHello: "على سبيل المثال، مرحبا",
    send: "إرسال",
    ReasonIfRejected: 'السبب في الرفض',
    Accepted: 'تم قبوله',
    Accept: 'قبول',
    Cancelled: 'تم الإلغاء',
    Cancel: 'إلغاء',
    Assign: 'تعيين',
    ShowHide: 'إظهار/إخفاء',
    PaymentMethod: 'طريقة الدفع',
    PaidAmount: 'المبلغ المدفوع',
    AvailableRiders: 'راكبون متاحون',
    Rider: 'راكب',
    AssignedTo: 'تم التعيين إلى',
    SelectStatus: 'اختر الحالة',
    OrderStatus: 'حالة الطلب',
    CurrentStatus: 'الحالة الحالية',
    PaymentStatus: 'حالة الدفع',
    Customer: 'الزبون',
    OrderDetails: 'تفاصيل الطلب',
    Charges: 'الرسوم',
    DeliveryCharges: 'رسوم التوصيل',
    Subtotal: 'المجموع الفرعي',
    Total: 'المجموع',
    Admin: 'المشرف',
    Stripe: 'سترايب',
    PHRiderName: 'جون دو',
    PHUserName: 'جوندو1122',
  },
};

export default ar;
